const IMAGE_EXTENSIONS = /\.(avif|bmp|gif|heic|heif|jpe?g|png|tiff?|webp|svg)$/i;

export function partitionUploadFiles<T extends Pick<File, "name" | "type" | "size">>(
  files: T[], accept: string, maxFileMB: number,
) {
  const accepted: T[] = [];
  const unsupported: T[] = [];
  const oversized: T[] = [];
  const empty: T[] = [];
  const limit = maxFileMB * 1024 * 1024;
  for (const file of files) {
    if (!matchesFileAccept(file, accept)) unsupported.push(file);
    else if (file.size === 0) empty.push(file);
    else if (file.size > limit) oversized.push(file);
    else accepted.push(file);
  }
  return { accepted, unsupported, oversized, empty };
}

/** File.type may be empty after dragging exported images from a file manager. */
export function matchesFileAccept(file: Pick<File, "name" | "type">, accept: string): boolean {
  const rules = accept.split(",").map(rule => rule.trim().toLowerCase()).filter(Boolean);
  const mime = (file.type || "").toLowerCase();
  const name = file.name.toLowerCase();
  return rules.length === 0 || rules.some(rule => {
    if (rule === "image/*" && !mime) return IMAGE_EXTENSIONS.test(name);
    if (rule.endsWith("/*")) return mime.startsWith(rule.slice(0, -1));
    if (rule.startsWith(".")) return name.endsWith(rule);
    return mime === rule;
  });
}
